import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteSecurityProfile } from '../../../../actions/security/SecurityProfile';

const DeleteSecurityProfileButton = ({ securityProfileId, dispatchDeleteSecurityProfile }) => {
  const [showModal, setShowModal] = React.useState(false);
  const onClickDelete = () => dispatchDeleteSecurityProfile({ securityProfileId })
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (  
    <Fragment>
      <ConfirmationModal 
      show={showModal}
      onClickConfirm={onClickDelete}
      onClickCancel={closeModal}
    />
      <Button color="danger" onClick={openModal}>
        Eliminar
      </Button>  
    </Fragment>
  )
};

DeleteSecurityProfileButton.propTypes = {
  securityProfileId: PropTypes.number.isRequired,
  dispatchDeleteSecurityProfile: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteSecurityProfile: deleteSecurityProfile
};

export default connect(null, mapDispatchToProps)(DeleteSecurityProfileButton);
